import React from 'react';
import CommonLayout from 'app/components/layout/common-layout';

const MainHome = () => {
  return <CommonLayout />;
};
export default MainHome;
